import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9b69e36"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"white"} }, "Please set a new password for future.", -1))
const _hoisted_2 = { style: {"display":"flex"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_a_form, { ref: "formRef" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, { name: "password" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              class: "custom-input-style",
              placeholder: "New Password",
              value: _ctx.password,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event))
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_button, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.login())),
                class: "login-btn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Save")
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancel())),
                class: "login-btn",
                style: {"margin-left":"10px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancel")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512)
  ], 64))
}